<template>
    <span v-html="symbol"></span>
</template>

<script>
export default {
    computed : {
        symbol () {
            return '&#' + this.$getAccount().currencyContext.unicodedecimal
                .split(', ')
                .join('&#');
        },
    },
}
</script>

<style scoped>

</style>
